import React, { FC, ChangeEvent } from "react";
import clsx from "clsx";

import styles from "./HopeScoreSelector.module.scss";

type Props = {
  name: string;
  value: number;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
};

const HopeScoreSelector: FC<Props> = ({ name, value, onChange }) => {
  return (
    <div className={styles.selector}>
      <label className={styles.label}>希望度</label>
      <div className={styles.body}>
        <span className={clsx(styles.scoreLabel, styles.blue)}>
          まだ
          <br />
          迷っている
        </span>
        <div className={styles.scoreList}>
          {[...Array(6)].map((_, index) => {
            const score = index + 1;
            return (
              <div key={score} className={styles.scoreItem}>
                <label className={styles.score}>
                  <input
                    key={score}
                    name={name}
                    type="radio"
                    value={score}
                    checked={value === score}
                    onChange={onChange}
                  />
                  <span className={styles.radioCustom} />
                </label>
              </div>
            );
          })}
        </div>
        <span className={clsx(styles.scoreLabel, styles.green)}>
          絶対に
          <br />
          叶えたい
        </span>
      </div>
    </div>
  );
};

export default HopeScoreSelector;
